import { Fragment } from 'react';
import * as dust from '@density/dust/dist/tokens/dust.tokens';

import FillCenter from 'components/fill-center/fill-center';
import AppBarFloor from 'components/app-bar-floor/app-bar-floor';

// shown when a feature flag has disabled one of the floor views (analysis, availability, planning)
export const DisabledFloorView: React.FC = () => {
  return (
    <Fragment>
      <AppBarFloor />
      <div style={{ backgroundColor: dust.Gray000, height: '100%' }}>
        <FillCenter>
          <div
            style={{
              padding: dust.Space4,
              border: `1px solid ${dust.Gray200}`,
              borderRadius: dust.Radius200,
              backgroundColor: dust.White,
            }}
          >
            This view has been disabled
          </div>
        </FillCenter>
      </div>
    </Fragment>
  );
};
